//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'taxonomyList'
    ])
  },
  data () {
    return {
      categories: [
        {
          icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_wechat.png',
          name: '微信营销',
          tabId: 1
        },
        {
          icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_weibo.png',
          name: '微博营销',
          tabId: 2
        },
        {
          icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_live.png',
          name: '网红直播',
          tabId: 3
        },
        {
          icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_video.png',
          name: '视频营销',
          tabId: 4
        },
        {
          icon: 'https://static.xinmeibao.com/assets_mobile/v2/nav_menu_news.png',
          name: '软文推广',
          tabId: 0
        }
      ]
    }
  },
  methods: {
    goSearch () {
      this.$router.push('/media?search=true')
      // wx.navigateTo({
      //   url: `../media/media?tab=news&search=true`
      // });
    },
    swiperChange (e) {
    },
    animationfinish (e) {
    }
  },
  mounted () {
    console.log(this.taxonomyList)
  }
}



// WEBPACK FOOTER //
// ./src/pages/mediaIndex/index.vue